import ManualVerificationForm from './ManualVerificationForm';

export default ManualVerificationForm;
